export default __webpack_public_path__ + "static/media/lines_color_down_left.0c6e16c8.png";